import React from "react";
import GridViewIcon from "public/next-public/common/icons/grid-view-icon.svg";
import ListViewIcon from "public/next-public/common/icons/list-view-icon.svg";
import styles from "./viewToggle.module.scss";

export type ViewMode = "grid" | "list";

type Props = {
  viewMode: ViewMode;
  toggleViewMode: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

function ViewToggle({ viewMode, toggleViewMode }: Props) {
  return (
    <div className={styles.ViewToggle}>
      <button
        className={`${styles.toggleBtn} ${viewMode === "grid" ? styles.active : ""}`}
        onClick={toggleViewMode}
        data-view="grid"
        aria-label="grid view"
      >
        <GridViewIcon />
      </button>
      <button
        className={`${styles.toggleBtn} ${viewMode === "list" ? styles.active : ""}`}
        onClick={toggleViewMode}
        data-view="list"
        aria-label="list view"
      >
        <ListViewIcon />
      </button>
    </div>
  );
}

export default ViewToggle;
